import React, { createContext, useContext, useEffect, useState, useMemo } from 'react';
import regionService from '../services/regionService';

const RegionContext = createContext({
    region: null,
    loading: true,
    refresh: async () => {},
});

export function RegionProvider({ children }) {
    const [region, setRegion] = useState(() => regionService.getCached());
    const [loading, setLoading] = useState(!region);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            const data = await regionService.getOrFetch();
            if (!cancelled) {
                setRegion(data);
                setLoading(false);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);

    const value = useMemo(
        () => ({
            region,
            loading,
            refresh: async () => {
                const data = await regionService.fetch();
                setRegion(data);
                return data;
            },
        }),
        [region, loading]
    );

    return <RegionContext.Provider value={value}>{children}</RegionContext.Provider>;
}

export function useRegion() {
    return useContext(RegionContext);
}

export default RegionContext;
